<template>
    <div class="bg-white article padding">
        <div v-if="article.id" >
            <div v-if="showTitle" class="header padding-bottom margin-bottom van-hairline--bottom">
                <div class="title text-xl text-black">{{article.title}}</div>
                <div class="created margin-top-sm text-gray">{{formatTime(article.createTime)}}</div>
            </div>
            <div class="margin-bottom content" v-html="article.content"></div>
        </div>
        <div v-else class="text-center text-gray">
            暂无相关文章信息
        </div>

    </div>

</template>

<script>
    import { util } from '@/libs/util'
    import { getArticle } from '@/api/article'
    import moment from 'moment'

    export default {
        name: "article-detail",
        data(){
            return {
                id: null,
                article: {},
                showTitle: true
            }
        },

        methods:{
            formatTime(e){
                return moment(e).format('YYYY-MM-DD HH:mm')
            },
            loadArticle(){
                util.showLoading('请稍候')
                getArticle(this.id,"banner").then(res => {
                    util.hideLoading();
                    const data = res.data
                    if (data.code == 0) {
                        this.article = data.article
                        if (this.showTitle == false) {
                            document.title = data.article.title || ''
                        }
                    } else {
                        util.showModal("获取任务详情失败",data.msg)
                    }
                })
            },
            loadData(){
                this.loadArticle()
            }
        },
        created() {
            this.id = this.$route.query.id
            this.showTitle = this.$route.query.showTitle != 'false'
            this.loadData()
        },
    }
</script>

<style lang="less">

    .article{
        .title{
            letter-spacing: 1px;
        }
        .content img{
            display: block;
            max-width: 100%;
            margin: 5px auto
        }
    }

</style>
